module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.texto != null) ? _c('div', {
    class: ['mensagem', 'u-margem-inferior-pequena', ("mensagem_cor-" + (_vm.tipo || 'erro'))],
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    class: ['far', ("" + (this.definirIcone(_vm.tipo) || 'fa-times-circle')), 'mensagem__icone']
  }), _vm._v(" "), _c('div', {
    staticClass: "mensagem__conteudo"
  }, [(_vm.titulo) ? _c('p', {
    staticClass: "mensagem__titulo"
  }, [_vm._v(_vm._s(this.titulo))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mensagem__texto",
    domProps: {
      "innerHTML": _vm._s(this.texto)
    }
  }), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2366035d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Alerta.vue
// module id = 1095
// module chunks = 1